var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('span',{staticClass:"co date",attrs:{"title":_vm.$t('datetime', {
            date: _vm.date,
            format: 'exact',
            locale: _vm.locale,
        })}},[_vm._v(_vm._s(_vm.$t('datetime', { date: _vm.date, format: _vm.format, locale: _vm.locale, customFormat: _vm.customFormat, })))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }